import { render } from "./inputCheckBox.vue?vue&type=template&id=8b68d8ca&scoped=true&ts=true"
import script from "./inputCheckBox.vue?vue&type=script&lang=ts"
export * from "./inputCheckBox.vue?vue&type=script&lang=ts"

import "./inputCheckBox.vue?vue&type=style&index=0&id=8b68d8ca&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b68d8ca"]])

export default __exports__